// The TypeScript equivalent of `replicate_web.metronome.BillingMetric`. Changes
// here need to also happen there.
export enum BillingMetric {
  AudioOutputCount = "audio_output_count",
  AudioOutputDurationSeconds = "audio_output_duration_seconds",
  CharacterInputCount = "character_input_count",
  CharacterOutputCount = "character_output_count",
  GenericOutputCount = "generic_output_count",
  ImageOutputCount = "image_output_count",
  ImageOutputPixelCount = "image_output_pixel_count",
  PageInputCount = "page_input_count",
  TokenInputCount = "token_input_count",
  TokenOutputCount = "token_output_count",
  TrainingStepCount = "training_step_count",
  UnspecifiedBillingMetric = "unspecified_billing_metric",
  VideoOutputCount = "video_output_count",
  VideoOutputDurationSeconds = "video_output_duration_seconds",
  VideoOutputTotalPixelCount = "video_output_total_pixel_count",
}

// The TypeScript equivalent of `replicate_web.metronome.InternalBillingMetric`.
// Changes here need to also happen there.
export enum InternalBillingMetric {
  ActiveTime = "active_time",
  IdleTime = "idle_time",
  RunCount = "run_count",
  RunTime = "run_time",
  SetupTime = "setup_time",
}
